<!--物流码明细-->
<template>
  <el-dialog title="物流码明细" :visible="true" :append-to-body=true width="50%" v-loading="loading" :before-close="handleClose">
    <!--表格-->
    <el-table ref="multipleTable" :data="tableData" height="350" border stripe style="width: 100%">
      <el-table-column prop="code_name" label="标签类型" fixed>
      </el-table-column>
      <el-table-column prop="logistics_code" label="物流码" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="real_stock_out_num" label="数量" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination style="margin: 20px 0" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalSize">
    </el-pagination>

  </el-dialog>

</template>

<script>
export default {
  name: "deliver-code",
  data() {
    return {
      loading: false,
      tableData: [],
      //分页
      pageNo: 1,
      pageSize: 20,
      totalSize: 0,
    };
  },
  props: {
    stock_out_sn: {
      type: String,
      default: "",
    },
  },
  methods: {
    getData() {
      let url = "/outwarehouses/" + this.stock_out_sn + "/datas";
      this.loading = true;
      this.$get("logistics", url, {
        lang: "",
        outwarehouse: this.stock_out_sn,
        per_page: this.pageSize,
        page: this.pageNo,
      })
        .then((res) => {
          this.loading = false;
          console.log(res);
          this.tableData = res.data;
          this.totalSize = res.meta.total;
        })
        .catch(function (error) {
          this.loading = false;
          console.log(error);
        });
    },
    /*分页*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getData();
    },
    handleClose() {
      this.$emit("handleClose");
    },
    del(data) {
      this.$confirm("是否要回退?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let url = "outwarehouses/" + this.stock_out_sn;
          this.$delete("pda", url, {
            data: {
              logistics_code: data.logistics_code,
              outwarehouses: this.stock_out_sn,
            },
          })
            .then((res) => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              if (this.tableData.length > 1) {
                this.getData();
              } else {
                this.$emit("done");
              }
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error.message,
              });
            });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error.message,
          });
        });
      //    let url = "";
      //     this.$delete("pda", url, {
      //         data: {

      //         },
      //     })
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
</style>